import { GetWalletDetailsResponse } from '@wix/ambassador-rise-integration-v1-wix-integration-provider/types';
import { getWalletDetails } from '@wix/ambassador-rise-integration-v1-wix-integration-provider/http';
import { Transactions } from '../monitoring/transactions';
import { ControllerFlowAPI } from '../types/types';
import { SPECS } from '../consts';

export class GetRiseWalletApi {
  private readonly flowAPI: ControllerFlowAPI;

  constructor({ flowAPI }: { flowAPI: ControllerFlowAPI }) {
    this.flowAPI = flowAPI;
  }

  async getWallet(
    currency: string,
  ): Promise<GetWalletDetailsResponse | undefined> {
    const shouldUseErrorHandler = this.flowAPI.experiments?.enabled?.(
      SPECS.ShouldUseErrorHandler,
    );

    this.flowAPI.panoramaClient?.transaction(Transactions.GetWallet).start();
    const response = shouldUseErrorHandler
      ? await this.flowAPI.errorHandler.withErrorHandler(
          () => this.flowAPI.httpClient.request(getWalletDetails({ currency })),
          {
            errorCodesMap: {
              applicationError: {
                FAILED_TO_GET_RISE_ACCOUNT: false,
                NON_MEMBER_IDENTITY: false,
              },
            },
          },
        )
      : await this.flowAPI.httpClient.request(getWalletDetails({ currency }));
    this.flowAPI.panoramaClient?.transaction(Transactions.GetWallet).finish();

    return response.data;
  }
}
